import { Notes, Appear, Image } from 'mdx-deck';
import highlight from '@mdx-deck/themes/syntax-highlighter-prism';
import Repl from "../../../../../../repl";
import Me from "../../../../../../Me";
import Reference from "../../../../../../Reference";
import Code from "../../../../../../Code";
import References from "../../../../../../references";
import WithBackground from "../../../../../../WithBackground";
import * as snippets from "../../../../../../snippets";
import theme from "../../../../../../theme";
import mapAndCompass from "../../../../../../images/map-and-compass-people.jpeg";
import what from "../../../../../../images/what.gif";
import comeOn from "../../../../../../images/come-on.gif";
import crossRoadSign from "../../../../../../images/cross-road-sign.jpeg";
import toThePeople from "../../../../../../images/to-you-the-people.webp";
import cool from "../../../../../../images/cool.jpg";
import goal from "../../../../../../images/goal.jpeg";
import functionsEverywhere from "../../../../../../images/functions-everywhere.jpeg";
import functionsEverywhereHappy from "../../../../../../images/functions-everywhere-happy.jpg";
import pooh01 from "../../../../../../images/pooh-v2-01.jpg";
import pooh02 from "../../../../../../images/pooh-v2-02.jpg";
import pure from "../../../../../../images/pure.jpeg";
import xkcdRandom from "../../../../../../images/xkcd-random.png";
import wallet from "../../../../../../images/wallet.jpeg";
import gorillaThinking from "../../../../../../images/gorilla-thinking.jpg";
import factoryWorkerSaw from "../../../../../../images/factory-wroker-saw.jpeg";
import sideEffects from "../../../../../../images/side-effects.jpg";
import pooh03 from "../../../../../../images/pooh-v2-03.jpg";
import imgCurry from "../../../../../../images/curry.jpeg";
import bricks from "../../../../../../images/bricks.jpg";
import constructionWorkerPipe from "../../../../../../images/construction-worker-pipe.jpeg";
import fractal from "../../../../../../images/fractal.jpg";
import compositionIsFractal from "../../../../../../images/composition-fractal.png";
import compassAndForest from "../../../../../../images/compass-and-forest.jpeg";
import neverStopExploring from "../../../../../../images/never-stop-exploring.jpeg";
import onlyYou from "../../../../../../images/only-you.png";
import imgQuestions from "../../../../../../images/questions.gif";
import React from 'react';
export default {
  Notes: Notes,
  Appear: Appear,
  Image: Image,
  highlight: highlight,
  Repl: Repl,
  Me: Me,
  Reference: Reference,
  Code: Code,
  References: References,
  WithBackground: WithBackground,
  snippets: snippets,
  theme: theme,
  mapAndCompass: mapAndCompass,
  what: what,
  comeOn: comeOn,
  crossRoadSign: crossRoadSign,
  toThePeople: toThePeople,
  cool: cool,
  goal: goal,
  functionsEverywhere: functionsEverywhere,
  functionsEverywhereHappy: functionsEverywhereHappy,
  pooh01: pooh01,
  pooh02: pooh02,
  pure: pure,
  xkcdRandom: xkcdRandom,
  wallet: wallet,
  gorillaThinking: gorillaThinking,
  factoryWorkerSaw: factoryWorkerSaw,
  sideEffects: sideEffects,
  pooh03: pooh03,
  imgCurry: imgCurry,
  bricks: bricks,
  constructionWorkerPipe: constructionWorkerPipe,
  fractal: fractal,
  compositionIsFractal: compositionIsFractal,
  compassAndForest: compassAndForest,
  neverStopExploring: neverStopExploring,
  onlyYou: onlyYou,
  imgQuestions: imgQuestions,
  React: React
};